export const ONBOARDING_STATUSES = [
  "pending",
  "completed",
  "dismissed",
];

export const DEFAULT_ONBOARDING = {
  status: "pending",
  analysisHintSeen: false,
};

export const normalizeOnboarding = (onboarding) => {
  if (!onboarding || typeof onboarding !== "object") {
    return { ...DEFAULT_ONBOARDING };
  }

  const status = ONBOARDING_STATUSES.includes(onboarding.status)
    ? onboarding.status
    : DEFAULT_ONBOARDING.status;

  return {
    status,
    analysisHintSeen:
      typeof onboarding.analysisHintSeen === "boolean"
        ? onboarding.analysisHintSeen
        : DEFAULT_ONBOARDING.analysisHintSeen,
  };
};

export const buildOnboardingUpdate = (onboarding, updates) => ({
  ...normalizeOnboarding(onboarding),
  ...updates,
});
